import React from 'react';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import TruckIcon from 'mdi-react/TruckIcon';
import styles from './BookStatus.module.scss';

type IStatus = 1 | 2 | 3 | 4 | 5 | undefined | number;

type Props = {
  status: IStatus;
  tripStatus?: any;
};

const statuses = {
  '1': 'Не підтверджена',
  '2': 'Підтверджена',
  '3': 'Видалена',
  '4': 'Відхилена',
  '5': 'Іншого менеджера',
  '6': 'Завершено',
};

const BookStatus: React.FC<Props> = ({ status, tripStatus }) => (
  <div className={styles.div}>
    <OverlayTrigger
      key={status}
      placement="top"
      // @ts-ignore
      overlay={<Tooltip id={`tooltip-${status}`}>{statuses[`${status}`]}</Tooltip>}
    >
      <>
        <div
          className={classNames(
            styles.bookCircle,
            status === 1 ? styles.blue : '',
            status === 2 ? styles.yellow : '',
            status === 4 ? styles.red : '',
            status === 5 ? styles.gray : '',
            status === 6 ? styles.green : '',
          )}
        />
        {tripStatus !== undefined && tripStatus[0] >= 3 && tripStatus[0] !== 9 ? (
          <TruckIcon className="mr-1" size={18} />
        ) : null}
      </>
    </OverlayTrigger>
  </div>
);

export default BookStatus;
